import { Tooltip } from '@/_components';

import { getPriceFrequencyLetterDisplay } from '../format-price-frequency-letter';

type PriceFrequencyAbbrevProps = {
  priceFrequency: { name: string } | null | undefined;
  className?: string;
};

/**
 * Renders M / A / O with a tooltip for the full frequency label (or em dash when missing).
 */
export function PriceFrequencyAbbrev({ priceFrequency, className }: PriceFrequencyAbbrevProps) {
  const { letter, tooltipLabel } = getPriceFrequencyLetterDisplay(priceFrequency);

  if (letter === '—') {
    return <span className={className}>—</span>;
  }

  return (
    <Tooltip content={tooltipLabel} placement="top" zIndex={50}>
      <span className={`cursor-default ${className ?? ''}`}>{letter}</span>
    </Tooltip>
  );
}
